import { Button } from '@/components/ui/button';

interface ChatUnavailableProps {
  onRetry: () => void;
  /** True while a retry is in flight, so the button cannot be fired twice. */
  retrying: boolean;
}

/**
 * The room could not be reached - and that is NOT the same as a dead link.
 *
 * It exists because the shell used to render S8 on every failure, which meant a
 * 429 from the per-address ceiling, a one-second network outage or a schema
 * parse that failed all told somebody holding a perfectly valid invitation that
 * her link was dead. §5 asks for expired and unknown to be indistinguishable
 * from each other; it never asked for the network to disguise itself as an
 * expired link, and §4.5 is explicit that a disconnection is a banner and never
 * a step backwards.
 *
 * So this screen says the opposite of S8: come back, try again. It carries a
 * retry because that is the whole difference - the dead-link screen offers
 * nothing to retry, and offering nothing is exactly what must not happen to an
 * interview that is still running.
 */
export function ChatUnavailable({ onRetry, retrying }: ChatUnavailableProps) {
  return (
    <section data-testid="chat-unavailable">
      <h1>La salle est momentanément injoignable</h1>
      <p>
        Votre lien est valable. La connexion n'a pas abouti - vous pouvez réessayer sans quitter
        cette page.
      </p>
      <Button type="button" onClick={onRetry} disabled={retrying}>
        {retrying ? 'Nouvelle tentative...' : 'Réessayer'}
      </Button>
    </section>
  );
}
